'use strict';

var react = require('react');
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

/* global Reflect, Promise */


var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}

var Loadable = function () {
  function Loadable(pageData) {
    this.pageData = pageData;
  }

  Loadable.prototype.setPageData = function (pageData) {
    this.pageData = pageData;
  };

  return Loadable;
}();

var Rakuten = function (_super) {
  __extends(Rakuten, _super);

  function Rakuten() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Rakuten.prototype.load = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , new Promise(function (resolve) {
              var scriptTag = document.createElement('script');
              scriptTag.src = 'https://apps.bostonglobe.com/common/js/rakuten/rakuten_global.js';
              scriptTag.onload = resolve;
              document.head.appendChild(scriptTag);
            })];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  Rakuten.prototype.execute = function () {// This method intentionally left blank.
  };

  return Rakuten;
}(Loadable);

var env = function env() {
  if (window.location.host.includes('dev')) {
    return 'apps-dev.bostonglobe.com';
  }

  if (window.location.host.includes('localhost')) {
    return 'localhost.bostonglobe.com';
  }

  return 'bostonglobe.com';
};

var Chartbeat = function (_super) {
  __extends(Chartbeat, _super);

  function Chartbeat() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Chartbeat.prototype.load = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        window._sf_startpt = new Date().getTime();
        window._sf_async_config = {
          uid: 8544,
          domain: env()
        };
        window._sf_async_config.path = location.pathname;
        window._sf_async_config.sections = this.pageData.section.toLowerCase();
        window._sf_async_config.authors = 'infographic';
        return [2
        /*return*/
        ];
      });
    });
  }; // eslint-disable-next-line class-methods-use-this


  Chartbeat.prototype.execute = function () {
    var loadChartbeat = function loadChartbeat(userInfo) {
      window._sf_endpt = new Date().getTime(); // eslint-disable-next-line

      var _cbq = window._cbq = window._cbq || []; // Verify that all meter object helpers exist before using them.


      if (window.meterObject && window.meterObject.helperFunctions && window.meterObject.helperFunctions.getChartbeatUserStatus) {
        /**
         * Determine if a user is paid, anonymous or logged in.
         * The documentation for this is confusing. Read and understand.
         * @see  CONSUMER-719
         * @see  http://support.chartbeat.com/docs/#usertype
         */
        var userStatus = window.meterObject.helperFunctions.getChartbeatUserStatus(userInfo);

        _cbq.push(['_acct', userStatus]);
      }

      var e = document.createElement('script');
      e.setAttribute('language', 'javascript');
      e.setAttribute('type', 'text/javascript');
      e.setAttribute('src', (document.location.protocol === 'https:' ? 'https://s3.amazonaws.com/' : 'http://') + "static.chartbeat.com/js/chartbeat.js");
      document.body.appendChild(e);
    };

    window.meterObject.observationController.addEventObserver('userStateChange', loadChartbeat);
  };

  return Chartbeat;
}(Loadable);

function getMetaContent(property) {
  var metas = document.getElementsByTagName('meta');

  for (var i = 0; i < metas.length; i += 1) {
    var prop = metas[i].getAttribute('property');

    if (prop === property) {
      return metas[i].getAttribute('content') || '';
    }
  }

  return '';
}
/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */


function decode(input) {
  try {
    return decodeURIComponent(input.replace(/\+/g, ' '));
  } catch (e) {
    return null;
  }
}
/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */


function querystring(query) {
  var parser = /([^=?#&]+)=?([^&]*)/g,
      result = {},
      part;

  while (part = parser.exec(query)) {
    var key = decode(part[1]),
        value = decode(part[2]); //
    // Prevent overriding of existing properties. This ensures that build-in
    // methods like `toString` or __proto__ are not overriden by malicious
    // querystrings.
    //
    // In the case if failed decoding, we want to omit the key/value pairs
    // from the result.
    //

    if (key === null || value === null || key in result) continue;
    result[key] = value;
  }

  return result;
}

var parse = querystring;

function getPageId(_a) {
  var _b;

  var _c = _a.meterParam,
      meterParam = _c === void 0 ? '' : _c,
      _d = _a.meterPath,
      meterPath = _d === void 0 ? false : _d;
  var title = ((_b = document.querySelector('title')) === null || _b === void 0 ? void 0 : _b.textContent) || '';
  var titleWithoutGlobe = title.split('- The Boston Globe')[0].trim();
  var alpha = titleWithoutGlobe.replace(/\W+/g, '-');
  var suffix = '';

  if (meterPath) {
    var pathname = window.location.pathname.split('/').filter(function (str) {
      return str !== '';
    }).join('-');
    var path = "-path-" + pathname;
    suffix += path;
  }

  if (meterParam.length > 0) {
    var search = parse(window.location.search);
    var paramValue = search[meterParam];
    var paramStr = paramValue ? "-" + meterParam + "-" + paramValue : '';
    suffix += paramStr;
  }

  return ("apps." + alpha + suffix).toLowerCase();
}
/* eslint-disable */


var omniturePageView = function omniturePageView(pageData) {
  var _a;

  var sAccount = 'nytbostonglobecom,nytbgglobal';

  var QueryString = function QueryString() {
    var vars = {}; // @ts-ignore

    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
      vars[key] = value;
    });
    return vars;
  };

  var queryParams = QueryString();
  var pageId = getPageId({});
  var title = (pageData === null || pageData === void 0 ? void 0 : pageData.title) || ((_a = document.querySelector('title')) === null || _a === void 0 ? void 0 : _a.textContent) || '';
  var titleWithoutGlobe = title.split('- The Boston Globe')[0].trim();
  /* eslint-disable */
  // This code was provided by Adobe and would be very hard to bring into our style.

  window.s = s_gi(sAccount);
  window.s.trackingServer = 'metrics.bostonglobe.com';
  window.s.trackingServerSecure = 'smetrics.bostonglobe.com';
  window.s.trackDownloadLinks = true;
  window.s.trackExternalLinks = true;
  window.s.trackInlineStats = true;
  window.s.linkLeaveQueryString = false;
  window.s.linkInternalFilters = 'localhost,facebook.com/sharer,twitter.com/intent,mailto,bostonglobe.com';
  window.s.linkExternalFilters = '';
  window.s.linkTrackVars = 'None';
  window.s.linkTrackEvents = 'None';
  window.s.usePlugins = true;
  window.s.p_gpv = new Function('k', 'u', '' + "var s=this,v='',i=u.indexOf('?'),q;if(k&&i>-1){q=u.substring(i+1);v" + "=s.pt(q,'&','p_gvf',k)}return v");
  window.s.p_gvf = new Function('t', 'k', '' + "if(t){var s=this,i=t.indexOf('='),p=i<0?t:t.substring(0,i),v=i<0?'T" + "rue':t.substring(i+1);if(p.toLowerCase()==k.toLowerCase())return s." + "epa(v)}return ''");
  window.s.getPreviousValue = new Function('v', 'c', 'el', '' + "var s=this,t=new Date,i,j,r='';t.setTime(t.getTime()+1800000);if(el" + "){if(s.events){i=s.split(el,',');j=s.split(s.events,',');for(x in i" + '){for(y in j){if(i[x]==j[y]){if(s.c_r(c)) r=s.c_r(c);v?s.c_w(c,v,t)' + ":s.c_w(c,'no value',t);return r}}}}}else{if(s.c_r(c)) r=s.c_r(c);v?" + "s.c_w(c,v,t):s.c_w(c,'no value',t);return r}");
  window.s.manageVars = new Function('c', 'l', 'f', '' + 'var s=this,vl,la,vla;l=l?l:"";f=f?f:1 ;if(!s[c])return false;vl="pa' + 'geName,purchaseID,channel,server,pageType,campaign,state,zip,events' + ',products,transactionID";for(var n=1;n<76;n++){vl+=",prop"+n+",eVar' + '"+n+",hier"+n;}if(l&&(f==1||f==2)){if(f==1){vl=l;}if(f==2){la=s.spl' + 'it(l,",");vla=s.split(vl,",");vl="";for(x in la){for(y in vla){if(l' + 'a[x]==vla[y]){vla[y]="";}}}for(y in vla){vl+=vla[y]?","+vla[y]:"";}' + '}s.pt(vl,",",c,0);return true;}else if(l==""&&f==1){s.pt(vl,",",c,0' + ');return true;}else{return false;}');
  window.s.wd = window;
  window.s.fl = new Function('x', 'l', '' + 'return x?(""+x).substring(0,l):x');
  window.s.pt = new Function('x', 'd', 'f', 'a', '' + 'var s=this,t=x,z=0,y,r,l="length";while(t){y=t.indexOf(d);y=y<0?t[l' + ']:y;t=t.substring(0,y);r=s[f](t,a);if(r)return r;z+=y+d[l];t=x.subs' + 'tring(z,x[l]);t=z<x[l]?t:""}return""');
  window.s.rep = new Function('x', 'o', 'n', '' + 'var a=new Array,i=0,j;if(x){if(x.split)a=x.split(o);else if(!o)for(' + 'i=0;i<x.length;i++)a[a.length]=x.substring(i,i+1);else while(i>=0){' + 'j=x.indexOf(o,i);a[a.length]=x.substring(i,j<0?x.length:j);i=j;if(i' + '>=0)i+=o.length}}x="";j=a.length;if(a&&j>0){x=a[0];if(j>1){if(a.joi' + 'n)x=a.join(n);else for(i=1;i<j;i++)x+=n+a[i]}}return x');
  window.s.ape = new Function('x', '' + 'var s=this,h="0123456789ABCDEF",f="+~!*()\\"",i,c=s.charSet,n,l,e,y' + '="";c=c?c.toUpperCase():"";if(x){x=""+x;if(s.em==3){x=encodeURIComp' + 'onent(x);for(i=0;i<f.length;i++){n=f.substring(i,i+1);if(x.indexOf(' + 'n)>=0)x=s.rep(x,n,"%"+n.charCodeAt(0).toString(16).toUpperCase())}}' + 'else if(c=="AUTO"&&("").charCodeAt){for(i=0;i<x.length;i++){c=x.sub' + 'string(i,i+1);n=x.charCodeAt(i);if(n>127){l=0;e="";while(n||l<4){e=' + 'h.substring(n%16,n%16+1)+e;n=(n-n%16)/16;l++}y+="%u"+e}else if(c=="' + '+")y+="%2B";else y+=escape(c)}x=y}else x=s.rep(escape(""+x),"+","%2' + 'B");if(c&&c!="AUTO"&&s.em==1&&x.indexOf("%u")<0&&x.indexOf("%U")<0)' + '{i=x.indexOf("%");while(i>=0){i++;if(h.substring(8).indexOf(x.subst' + 'ring(i,i+1).toUpperCase())>=0)return x.substring(0,i)+"u00"+x.subst' + 'ring(i);i=x.indexOf("%",i)}}}return x');
  window.s.epa = new Function('x', '' + 'var s=this,y,tcf;if(x){x=s.rep(""+x,"+"," ");if(s.em==3){tcf=new Fu' + 'nction("x","var y,e;try{y=decodeURIComponent(x)}catch(e){y=unescape' + '(x)}return y");return tcf(x)}else return unescape(x)}return y');
  window.s.parseUri = new Function('u', '' + 'if(u){u=u+"";u=u.indexOf(":")<0&&u.indexOf("//")!=0?(u.indexOf("/")' + '==0?"/":"//")+u:u}u=u?u+"":window.location.href;var e,a=document.cr' + 'eateElement("a"),l=["href","protocol","host","hostname","port","pat' + 'hname","search","hash"],p,r={href:u,toString:function(){return this' + '.href}};a.setAttribute("href",u);for(e=1;e<l.length;e++){p=l[e];r[p' + ']=a[p]||""}delete a;p=r.pathname||"";if(p.indexOf("/")!=0)r.pathnam' + 'e="/"+p;return r');
  window.s.gtfs = new Function('' + 'var w=window,l=w.location,d=document,u;if(!l.origin)l.origin=l.prot' + 'ocol+"//"+l.hostname+(l.port?":"+l.port:"");u=l!=w.parent.location?' + 'd.referrer:d.location;return{location:s.parseUri(u)}');

  var s_doPlugins = function s_doPlugins() {
    // 's_pv' and 's_p6' are cookie names
    // marketing.adobe.com/resources/help/en_US/sc/implement/getPreviousValue.html
    window.s.prop37 = s.getPreviousValue(s.pageName, 's_pv');
    window.s.prop73 = s.getPreviousValue(s.prop6, 's_p6');
  };

  window.s.doPlugins = s_doPlugins;

  var getProperty = function getProperty(key) {
    if (pageData && pageData[key]) {
      return pageData[key];
    }

    return getMetaContent(key) || '';
  };

  window.s.pageName = getProperty('section').toLowerCase() + " | " + titleWithoutGlobe;
  window.s.channel = getProperty('section').toLowerCase();
  window.s.prop1 = getProperty('section').toLowerCase();
  window.s.prop3 = getProperty('author');
  window.s.prop5 = getProperty('otherSections');
  window.s.prop6 = 'Article Page | Globe Story';
  window.s.prop7 = queryParams.p1;
  window.s.prop8 = getProperty('publishDate');
  window.s.prop9 = getProperty('wordCount');
  window.s.prop18 = window.location.hostname === 'apps.bostonglobe.com' ? 'Live' : 'Dev';
  window.s.prop26 = queryParams.s_campaign;
  window.s.prop41 = window.s.eVar41 = 'BostonGlobe.com';
  window.s.prop43 = window.location.href;
  window.s.prop49 = getProperty('meter') === 'false' ? 'exempt' : 'non-exempt';
  window.s.prop63 = '2.9.0';
  window.s.prop67 = pageId;
  window.s.prop68 = titleWithoutGlobe;
  window.s.eVar1 = queryParams.p1;
  window.s.eVar15 = getProperty('section').toLowerCase() + " | " + titleWithoutGlobe;
  window.s.eVar67 = pageId;
  window.s.eVar70 = getProperty('test_variant'); // pageLayout

  var pageLayout = getProperty('pageLayout');
  if (pageLayout) window.s.prop4 = pageLayout;
  /* eslint-enable */
};

var Omniture = function (_super) {
  __extends(Omniture, _super);

  function Omniture() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.isDev = false;
    return _this;
  }

  Omniture.prototype.load = function () {
    return __awaiter(this, void 0, void 0, function () {
      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.isDev = window.location.hostname.indexOf('dev') > 1 || window.location.hostname.indexOf('localhost') > 1;
            return [4
            /*yield*/
            , new Promise(function (resolve) {
              var scriptTag = document.createElement('script');
              scriptTag.src = "//apps" + (_this.isDev ? '-dev' : '') + ".bostonglobe.com/common/js/omniture/AppMeasurement.js";
              scriptTag.onload = resolve;
              document.head.appendChild(scriptTag);
            })];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  Omniture.prototype.execute = function () {
    omniturePageView(this.pageData);
  };

  return Omniture;
}(Loadable);

var Meter = function (_super) {
  __extends(Meter, _super);

  function Meter(pageData) {
    var _this = _super.call(this, pageData) || this;

    _this.cssFile = 'https://meter.bostonglobe.com/css/style.css';
    _this.jsFile = 'https://meter.bostonglobe.com/js/meter.js';

    if (pageData.preExecuteCallback) {
      _this.preExecuteCallback = pageData.preExecuteCallback;
    }

    return _this;
  }

  Meter.prototype.load = function () {
    return __awaiter(this, void 0, void 0, function () {
      var styleTag;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            window.methode = window.methode || {};

            if (window.location.hostname.indexOf('apps-dev') > -1) {
              this.cssFile = 'https://meter-qa.bostonglobe.com/css/style.css';
              this.jsFile = 'https://meter-qa.bostonglobe.com/js/meter.js';
            }

            styleTag = document.createElement('link');
            styleTag.href = this.cssFile;
            styleTag.rel = 'stylesheet';
            document.head.appendChild(styleTag);
            return [4
            /*yield*/
            , new Promise(function (resolve) {
              var scriptTag = document.createElement('script');
              scriptTag.src = _this.jsFile;
              scriptTag.onload = resolve;
              document.head.appendChild(scriptTag);
            })];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  Meter.prototype.execute = function () {
    var path = "//" + window.location.host + window.location.pathname;
    var _a = this.pageData,
        pageId = _a.pageId,
        meter = _a.meter,
        hideSocialConnect = _a.hideSocialConnect,
        hideProgressBar = _a.hideProgressBar;
    window.meterObject.options = {
      hideSocialConnect: hideSocialConnect,
      hideProgressBar: hideProgressBar
    };
    window.meterObject.updateBaseURL('https://bostonglobe.com');

    if (this.preExecuteCallback) {
      this.preExecuteCallback();
    }

    window.meterObject.executeMeter({
      loid: pageId,
      uuid: pageId,
      exemptFromMeter: !meter,
      pathURL: path
    });
  };

  return Meter;
}(Loadable);

var initialize = function initialize(pageData) {
  return __awaiter(void 0, void 0, void 0, function () {
    var rakuten, chartbeat, omniture, analyticsPromises, meter;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          rakuten = new Rakuten(pageData);
          chartbeat = new Chartbeat(pageData);
          omniture = new Omniture(pageData);
          analyticsPromises = [rakuten.load(), chartbeat.load(), omniture.load()];
          return [4
          /*yield*/
          , Promise.all(analyticsPromises)];

        case 1:
          _a.sent();

          meter = new Meter(pageData);
          return [4
          /*yield*/
          , meter.load()];

        case 2:
          _a.sent();

          return [2
          /*return*/
          , {
            rakuten: rakuten,
            chartbeat: chartbeat,
            omniture: omniture,
            meter: meter
          }];
      }
    });
  });
};

var useBusiness = function useBusiness(pageData) {
  var instances = react.useRef(null);
  react.useEffect(function () {
    // Immediately-executing function expression, since useEffect only expects the return value
    // to be a callback for unbinding, whereas async functions always return a Promise.
    (function () {
      return __awaiter(void 0, void 0, void 0, function () {
        var _a;

        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              if (!!instances.current) return [3
              /*break*/
              , 2];
              _a = instances;
              return [4
              /*yield*/
              , initialize(pageData)];

            case 1:
              _a.current = _b.sent();
              return [3
              /*break*/
              , 3];

            case 2:
              Object.keys(instances.current).forEach(function (instanceKey) {
                instances.current[instanceKey].setPageData(pageData);
              });
              _b.label = 3;

            case 3:
              Object.keys(instances.current).forEach(function (instanceKey) {
                instances.current[instanceKey].execute();
              });
              return [2
              /*return*/
              ];
          }
        });
      });
    })();
  }, [pageData]);

  var onPageView = function onPageView(newPageData) {
    instances.current.forEach(function (instance) {
      return instance.setPageData(newPageData);
    });
  };

  return {
    onPageView: onPageView
  };
};

module.exports = useBusiness;